import script from "./Saturation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Saturation.vue?vue&type=script&lang=ts&setup=true"

import "./Saturation.vue?vue&type=style&index=0&id=c79c0446&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c79c0446"]])

export default __exports__